module.exports = __webpack_public_path__ + "img/chart-bottom.55613c90.svg";